


















































































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import InterestRateType from '@/models/Products/InterestRateType';
import ListUtils from '@/lib/listUtils';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import PeriodType from '@/models/Shared/PeriodType';
import InterestCalculatedOnBalanceType from "@/models/Products/InterestCalculatedOnBalanceType";
import DayOfWeek from '@/models/Shared/DayOfWeek';
import Month from "@/models/Shared/Month";
import PostingScheduleType from "@/models/Shared/PostingScheduleType";
import ProductSubType from '@/models/Products/ProductSubType';

@Component({ name: 'DepositInterestSettingsEdit', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    InterestRateType = InterestRateType;
    InterestCalculatedOnBalanceType = InterestCalculatedOnBalanceType;
    PeriodType = PeriodType;

    @Prop({ required: true })
    isCreate: boolean

    @Prop({ required: false })
    productSubType: ProductSubType

    get productVM() {
        if (this.isCreate) {
            if (this.productSubType === ProductSubType.DepositFixedTerm || this.productSubType === ProductSubType.DepositSavingsAccount) {
                ProductWizardModule.createProductViewModel.depositInterestSettingsAvailable = true;
            }
            return ProductWizardModule.createProductViewModel;
        }
        return ProductDetailsModule.productVM;
    }

    get rateSourceOptions() {
        if (this.isCreate) {
            return ProductWizardModule.rateSources;
        }
        return ProductDetailsModule.rateSources;
    }

    get interestRateTypeOptions() {
        return ListUtils.interestRateTypeOptions();
    }

    get interestCalculatedOnOptions() {
        return ListUtils.interestCalculatedOnOptions();
    }

    get interestPostedTypeOptions() {
        return ListUtils.interestPostedTypeOptions();
    }

    get postingScheduleTypeOptions() {
        // For now depending on the product type we want to limit the options here to avoid confusion with what is supported
        if (this.productSubType === ProductSubType.DepositFixedTerm || this.productSubType === ProductSubType.DepositNoticeAccount) {
            return ListUtils.postingScheduleTypeOptionsForFixedTerm();
        }
        else {
            return ListUtils.postingScheduleTypeOptions();
        }
    }

    get periodTypeOptions() {
        return ListUtils.periodTypeOptions();
    }

    get nonWorkingDaysOptions() {
        return ListUtils.nonWorkingDaysOptions();
    }

    get dayOfWeekOptions() {
        return ListUtils.dayOfWeekOptions();
    }

    get dayOfMonthOptions() {
        return ListUtils.dayOfMonthOptions();
    }

    get monthOptions() {
        return ListUtils.monthOptions();
    }

    get daysInYearOptions() {
        return ListUtils.interestDaysInYearOptions();
    }

    get baseRateOptions() {
        return ListUtils.interestBaseRateOptions();
    }

    get isFixedSchedule() {
        return this.productVM.depositInterestSettings.postingScheduleType === PostingScheduleType.FixedSchedule;
    }

    // Resets valies for accruedPeriod based on periodType to avoid sending bad data to API
    @Watch('productVM.depositInterestSettings.accruedPeriodType')
    async onAccruedPeriodTypeChanged(periodType: string) {
        if (periodType === PeriodType.Day) {
            this.productVM.depositInterestSettings.accruedPeriodValue = 1;
            this.productVM.depositInterestSettings.accruedPeriodOnDayOfWeek = undefined;
            this.productVM.depositInterestSettings.accruedPeriodOnDayOfMonth = undefined;
            this.productVM.depositInterestSettings.accruedPeriodOnMonth = undefined;
        }
        if (periodType === PeriodType.Week) {
            this.productVM.depositInterestSettings.accruedPeriodValue = 1;
            this.productVM.depositInterestSettings.accruedPeriodOnDayOfWeek = DayOfWeek.Monday;
            this.productVM.depositInterestSettings.accruedPeriodOnDayOfMonth = undefined;
            this.productVM.depositInterestSettings.accruedPeriodOnMonth = undefined;
        }
        if (periodType === PeriodType.Month || periodType === PeriodType.Quarter) {
            this.productVM.depositInterestSettings.accruedPeriodValue = 1;
            this.productVM.depositInterestSettings.accruedPeriodOnDayOfWeek = undefined;
            this.productVM.depositInterestSettings.accruedPeriodOnDayOfMonth = undefined;
            this.productVM.depositInterestSettings.accruedPeriodOnMonth = undefined;
        }
        if (periodType === PeriodType.Year) {
            this.productVM.depositInterestSettings.accruedPeriodValue = 1;
            this.productVM.depositInterestSettings.accruedPeriodOnDayOfWeek = undefined;
            this.productVM.depositInterestSettings.accruedPeriodOnDayOfMonth = undefined;
            this.productVM.depositInterestSettings.accruedPeriodOnMonth = Month.January;
        }
    }

    // Resets valies for postedPeriod based on periodType to avoid sending bad data to API
    @Watch('productVM.depositInterestSettings.postedPeriodType')
    async onPostedPeriodTypeChanged(periodType: string) {
        if (periodType === PeriodType.Day) {
            this.productVM.depositInterestSettings.postedPeriodValue = 1;
            this.productVM.depositInterestSettings.postedPeriodOnDayOfWeek = undefined;
            this.productVM.depositInterestSettings.postedPeriodOnDayOfMonth = undefined;
            this.productVM.depositInterestSettings.postedPeriodOnMonth = undefined;
        }
        if (periodType === PeriodType.Week) {
            this.productVM.depositInterestSettings.postedPeriodValue = 1;
            this.productVM.depositInterestSettings.postedPeriodOnDayOfWeek = DayOfWeek.Monday;
            this.productVM.depositInterestSettings.postedPeriodOnDayOfMonth = undefined;
            this.productVM.depositInterestSettings.postedPeriodOnMonth = undefined;
        }
        if (periodType === PeriodType.Month || periodType === PeriodType.Quarter) {
            this.productVM.depositInterestSettings.postedPeriodValue = 1;
            this.productVM.depositInterestSettings.postedPeriodOnDayOfWeek = undefined;
            this.productVM.depositInterestSettings.postedPeriodOnDayOfMonth = 1;
            this.productVM.depositInterestSettings.postedPeriodOnMonth = undefined;
        }
        if (periodType === PeriodType.Year) {
            this.productVM.depositInterestSettings.postedPeriodValue = 1;
            this.productVM.depositInterestSettings.postedPeriodOnDayOfWeek = undefined;
            this.productVM.depositInterestSettings.postedPeriodOnDayOfMonth = 1;
            this.productVM.depositInterestSettings.postedPeriodOnMonth = Month.January;
        }
    }

}
